'use strict';

export const BIM_TYPE = {
    CANCELLATION: 'CANCELLATION',
    MODIFICATION: 'MODIFICATION',
};

export const BIM_CANCELLATION_TYPE = {
    VOLUNTARY: 'VOLUNTARY',
    INVOLUNTARY: 'INVOLUNTARY',
};

export const BIM_SEMANTIC = {
    INFORMATIVE: 'INFORMATIVE',
    CRITICAL: 'CRITICAL',
    SUCCESSFUL: 'SUCCESSFUL',
};

export const BIM_STATUS = {
    OPEN_TICKET_PENDING: 'OPEN_TICKET_PENDING',
    ALL_OPEN_TICKET_PENDING: 'ALL_OPEN_TICKET_PENDING',
    OPEN_TICKET_ACCEPTED: 'OPEN_TICKET_ACCEPTED',
    ALL_OPEN_TICKET_ACCEPTED: 'ALL_OPEN_TICKET_ACCEPTED',
    REFUND_WAITING_CONSENT: 'REFUND_WAITING_CONSENT',
    CUSTOMER_ALTERNATIVE_REQUESTED: 'CUSTOMER_ALTERNATIVE_REQUESTED',
    CUSTOMER_ALTERNATIVE_ISSUED: 'CUSTOMER_ALTERNATIVE_ISSUED',
    ALL_REFUND_WAITING_CONSENT: 'ALL_REFUND_WAITING_CONSENT',
    REFUND_NOT_MANAGED_BY_EDO: 'REFUND_NOT_MANAGED_BY_EDO',
    ALL_REFUND_NOT_MANAGED_BY_EDO: 'ALL_REFUND_NOT_MANAGED_BY_EDO',
    REFUND_MERCHANT: 'REFUND_MERCHANT',
    REFUND_NO_MERCHANT: 'REFUND_NO_MERCHANT',
    REFUND_WITH_STATUS: 'REFUND_WITH_STATUS',
    REFUND_VOLUNTARY: 'REFUND_VOLUNTARY',
    ALL_REFUND: 'ALL_REFUND',
    BANKRUPTCY: 'BANKRUPTCY',
    ALL_BANKRUPTCY: 'ALL_BANKRUPTCY',
    CONTACT_AIRLINE: 'CONTACT_AIRLINE',
    ALL_CONTACT_AIRLINE: 'ALL_CONTACT_AIRLINE',
    MANAGED_BY_TOUCHLESS: 'MANAGED_BY_TOUCHLESS',
    ALL_MANAGED_BY_TOUCHLESS: 'ALL_MANAGED_BY_TOUCHLESS',
    MANAGED_BY_ICM: 'MANAGED_BY_ICM',
    ALL_MANAGED_BY_ICM: 'ALL_MANAGED_BY_ICM',
    MANUAL_AIRLINE_ALTERNATIVE: 'MANUAL_AIRLINE_ALTERNATIVE',
    ALL_MANUAL_AIRLINE_ALTERNATIVE: 'ALL_MANUAL_AIRLINE_ALTERNATIVE',
    RESOLVED: 'RESOLVED',
    ALL_RESOLVED: 'ALL_RESOLVED',
    RESOLVED_BY_CUSTOMER: 'RESOLVED_BY_CUSTOMER',
    ALL_RESOLVED_BY_CUSTOMER: 'ALL_RESOLVED_BY_CUSTOMER',
    REDEMPTION_PENDING: 'REDEMPTION_PENDING',
    ALL_REDEMPTION_PENDING: 'ALL_REDEMPTION_PENDING',
    PENDING_CLASSIFICATION: 'PENDING_CLASSIFICATION',
    ALL_PENDING_CLASSIFICATION: 'ALL_PENDING_CLASSIFICATION',
    ALL_CRITICAL: 'ALL_CRITICAL',
    ALL_INFORMATIVE: 'ALL_INFORMATIVE',
    ALL_SUCCESSFUL: 'ALL_SUCCESSFUL',
    OPEN_TICKET_REJECTED: 'OPEN_TICKET_REJECTED',
    REFUND: 'REFUND',
    MMB: 'MMB',
};

export const BIM_CANCELLATION_STATUS = {
    OPEN_TICKET_ACCEPTED: 'OPEN_TICKET_ACCEPTED',
    OPEN_TICKET_PENDING: 'OPEN_TICKET_PENDING',
    CONTACT_AIRLINE: 'CONTACT_AIRLINE',
    BANKRUPTCY: 'BANKRUPTCY',
    REFUND_WAITING_CONSENT: 'REFUND_WAITING_CONSENT',
    CUSTOMER_ALTERNATIVE_REQUESTED: 'CUSTOMER_ALTERNATIVE_REQUESTED',
    CUSTOMER_ALTERNATIVE_ISSUED: 'CUSTOMER_ALTERNATIVE_ISSUED',
    REFUND_NOT_MANAGED_BY_EDO: 'REFUND_NOT_MANAGED_BY_EDO',
    MANAGED_BY_TOUCHLESS: 'MANAGED_BY_TOUCHLESS',
    MANAGED_BY_ICM: 'MANAGED_BY_ICM',
    MANUAL_AIRLINE_ALTERNATIVE: 'MANUAL_AIRLINE_ALTERNATIVE',
    REFUND_MERCHANT: 'REFUND_MERCHANT',
    REFUND_NO_MERCHANT: 'REFUND_NO_MERCHANT',
    REFUND_WITH_STATUS: 'REFUND_WITH_STATUS',
    REFUND_VOLUNTARY: 'REFUND_VOLUNTARY',
    RESOLVED: 'RESOLVED',
    RESOLVED_BY_CUSTOMER: 'RESOLVED_BY_CUSTOMER',
    REDEMPTION_PENDING: 'REDEMPTION_PENDING',
    PENDING_CLASSIFICATION: 'PENDING_CLASSIFICATION',
    // Fake cancellation status in BIM should be deprecated
    OPEN_TICKET_REJECTED: 'OPEN_TICKET_REJECTED',
    REFUND: 'REFUND',
};

export const BIM_STATUS_NAME_GROUPS = {
    OPEN_TICKET: 'OPEN_TICKET',
    CASH_REFUND: 'CASH_REFUND',
    GENERAL_INVOLUNTARY: 'GENERAL_INVOLUNTARY',
    GENERAL_VOLUNTARY: 'GENERAL_VOLUNTARY',
};

export const BIM_STATUS_GROUPS = {
    [BIM_STATUS_NAME_GROUPS.OPEN_TICKET]: [
        BIM_CANCELLATION_STATUS.OPEN_TICKET_PENDING,
        BIM_CANCELLATION_STATUS.OPEN_TICKET_ACCEPTED,
        BIM_CANCELLATION_STATUS.REDEMPTION_PENDING,
    ],
    [BIM_STATUS_NAME_GROUPS.CASH_REFUND]: [
        BIM_CANCELLATION_STATUS.REFUND_MERCHANT,
        BIM_CANCELLATION_STATUS.REFUND_NO_MERCHANT,
        BIM_CANCELLATION_STATUS.REFUND_WITH_STATUS,
        BIM_CANCELLATION_STATUS.REFUND_VOLUNTARY,
    ],
    [BIM_STATUS_NAME_GROUPS.GENERAL_INVOLUNTARY]: [
        BIM_CANCELLATION_STATUS.REFUND_WAITING_CONSENT,
        BIM_CANCELLATION_STATUS.CUSTOMER_ALTERNATIVE_REQUESTED,
        BIM_CANCELLATION_STATUS.CUSTOMER_ALTERNATIVE_ISSUED,
        BIM_CANCELLATION_STATUS.REFUND_NOT_MANAGED_BY_EDO,
        BIM_CANCELLATION_STATUS.BANKRUPTCY,
        BIM_CANCELLATION_STATUS.CONTACT_AIRLINE,
        BIM_CANCELLATION_STATUS.PENDING_CLASSIFICATION,
        BIM_CANCELLATION_STATUS.MANAGED_BY_TOUCHLESS,
    ],
};

export const BIM_CANCELLATION_STATUS_GROUPS = {
    CRITICAL: {
        CANCELLATIONS: Odigeo._.pick(BIM_CANCELLATION_STATUS,
            'OPEN_TICKET_PENDING',
            'CONTACT_AIRLINE',
            'REFUND_WAITING_CONSENT',
            'BANKRUPTCY',
            'MANAGED_BY_ICM',
            'MANUAL_AIRLINE_ALTERNATIVE',
            'MMB',
            'REFUND_NOT_MANAGED_BY_EDO'),
    },
    INFORMATIVE: {
        CANCELLATIONS: Odigeo._.pick(BIM_CANCELLATION_STATUS,
            'OPEN_TICKET_REJECTED',
            'REDEMPTION_PENDING',
            'RESOLVED',
            'RESOLVED_BY_CUSTOMER',
            'REFUND',
            'REFUND_WITH_STATUS',
            'REFUND_MERCHANT',
            'REFUND_NO_MERCHANT',
            'REFUND_VOLUNTARY',
            'PENDING_CLASSIFICATION',
            'CUSTOMER_ALTERNATIVE_REQUESTED',
            'MANAGED_BY_TOUCHLESS'),
        MAPPING_FN: (cancellation) => [
            BIM_CANCELLATION_STATUS.OPEN_TICKET_REJECTED,
            BIM_CANCELLATION_STATUS.REFUND_WITH_STATUS,
            BIM_CANCELLATION_STATUS.REFUND_MERCHANT,
            BIM_CANCELLATION_STATUS.REFUND_NO_MERCHANT,
            BIM_CANCELLATION_STATUS.REFUND_VOLUNTARY,
            BIM_CANCELLATION_STATUS.CUSTOMER_ALTERNATIVE_REQUESTED,
        ].includes(cancellation) ?
            BIM_CANCELLATION_STATUS.REFUND :
            cancellation,
    },
    SUCCESSFUL: {
        CANCELLATIONS: Odigeo._.pick(BIM_CANCELLATION_STATUS,
            'OPEN_TICKET_ACCEPTED',
            'CUSTOMER_ALTERNATIVE_ISSUED'),
    },
};

export const BIM_CANCELLATION_RESOLUTION_TYPE = {
    BSP_LINK: 'BSP_LINK',
    MANAGED_BY_TOUCHLESS: 'MANAGED_BY_TOUCHLESS',
    MANAGED_BY_ICM: 'MANAGED_BY_ICM',
    MANUAL: 'MANUAL',
    NOT_VALID: 'NOT_VALID',
    OPEN_TICKET_WITH_CONSENT: 'OPEN_TICKET_WITH_CONSENT',
    OPEN_TICKET_WITHOUT_CONSENT: 'OPEN_TICKET_WITHOUT_CONSENT',
    PENDING_CLASSIFICATION: 'PENDING_CLASSIFICATION',
    REFUND_WAITING_CONSENT: 'REFUND_WAITING_CONSENT',
    REFUND_NOT_MANAGED_BY_EDO: 'REFUND_NOT_MANAGED_BY_EDO',
    CUSTOMER_ALTERNATIVE_ISSUED: 'CUSTOMER_ALTERNATIVE_ISSUED',
    RESOLVED_BY_CUSTOMER: 'RESOLVED_BY_CUSTOMER',
    RESOLVED: 'RESOLVED',
    VOLUNTARY: 'VOLUNTARY',
};

export const BIM_CANCELLATION_CLASSIFICATION_TYPE = {
    AIRLINE_ALTERNATIVE: 'AIRLINE_ALTERNATIVE',
    ATC_AUTOMATIC: 'ATC_AUTOMATIC',
    ATC_MANUAL: 'ATC_MANUAL',
    BANKRUPTCY: 'BANKRUPTCY',
    BSP_EXTERNAL: 'BSP_EXTERNAL',
    BSP_LCC: 'BSP_LCC',
    BSP_LINK: 'BSP_LINK',
    CASHOUT: 'CASHOUT',
    COMMERCIAL_RELATIONSHIP: 'COMMERCIAL_RELATIONSHIP',
    CUSTOMER_DIRECT_RESOLUTION: 'CUSTOMER_DIRECT_RESOLUTION',
    FREE_REBOOKING_MANUAL: 'FREE_REBOOKING_MANUAL',
    MANUAL: 'MANUAL',
    NO_CASH: 'NO_CASH',
    OPEN_TICKET_ERROR: 'OPEN_TICKET_ERROR',
    OPEN_TICKET_WITH_CONSENT: 'OPEN_TICKET_WITH_CONSENT',
    OPEN_TICKET_WITHOUT_CONSENT: 'OPEN_TICKET_WITHOUT_CONSENT',
    RESOLVED: 'RESOLVED',
    SEND_TO_AIRLINES: 'SEND_TO_AIRLINES',
    TF_AUTOMATIC: 'TF_AUTOMATIC',
    TF_BSM: 'TF_BSM',
    LC_CASH_REFUND: 'LC_CASH_REFUND',
    VOLUNTARY: 'VOLUNTARY',
    MANUAL_REFUND: 'MANUAL_REFUND',
};

export const MANUAL_REFUND_CLASSIFICATIONS = [
    BIM_CANCELLATION_CLASSIFICATION_TYPE.ATC_AUTOMATIC,
    BIM_CANCELLATION_CLASSIFICATION_TYPE.ATC_MANUAL,
    BIM_CANCELLATION_CLASSIFICATION_TYPE.BSP_LCC,
    BIM_CANCELLATION_CLASSIFICATION_TYPE.BSP_EXTERNAL,
    BIM_CANCELLATION_CLASSIFICATION_TYPE.BSP_LINK,
    BIM_CANCELLATION_CLASSIFICATION_TYPE.COMMERCIAL_RELATIONSHIP,
    BIM_CANCELLATION_CLASSIFICATION_TYPE.MANUAL,
    BIM_CANCELLATION_CLASSIFICATION_TYPE.SEND_TO_AIRLINES,
    BIM_CANCELLATION_CLASSIFICATION_TYPE.TF_AUTOMATIC,
    BIM_CANCELLATION_CLASSIFICATION_TYPE.TF_BSM,
    BIM_CANCELLATION_CLASSIFICATION_TYPE.CASHOUT,
    BIM_CANCELLATION_CLASSIFICATION_TYPE.MANUAL_REFUND,
    BIM_CANCELLATION_CLASSIFICATION_TYPE.FREE_REBOOKING_MANUAL,
    BIM_CANCELLATION_CLASSIFICATION_TYPE.LC_CASH_REFUND,
];

export const BIM_INCIDENT_STATUS = {
    CUSTOMER_CANCELLATION_CHOSEN: 'CUSTOMER_CANCELLATION_CHOSEN',
    WAITING_FOR_CUSTOMER_CHOICE: 'WAITING_FOR_CUSTOMER_CHOICE',
};

export const NOTIFICATIONS_CONTENT = {
    TITLE_WITH_ITINERARY_VARIATION: [
        BIM_STATUS.MMB,
        BIM_STATUS.CONTACT_AIRLINE,
        BIM_STATUS.ALL_CONTACT_AIRLINE,
        BIM_STATUS.REFUND_WAITING_CONSENT,
        BIM_STATUS.ALL_REFUND_WAITING_CONSENT,
        BIM_STATUS.BANKRUPTCY,
        BIM_STATUS.ALL_BANKRUPTCY,
        BIM_STATUS.OPEN_TICKET_PENDING,
        BIM_STATUS.ALL_OPEN_TICKET_PENDING,
        BIM_STATUS.ALL_CRITICAL,
        BIM_STATUS.REDEMPTION_PENDING,
        BIM_STATUS.REFUND_NOT_MANAGED_BY_EDO,
        BIM_STATUS.ALL_REFUND_NOT_MANAGED_BY_EDO,
        BIM_STATUS.MANAGED_BY_ICM,
        BIM_STATUS.ALL_MANAGED_BY_ICM,
        BIM_STATUS.MANUAL_AIRLINE_ALTERNATIVE,
        BIM_STATUS.ALL_MANUAL_AIRLINE_ALTERNATIVE,
    ],
    TITLE_WITH_PNRS_HANDLED: [
        BIM_STATUS.ALL_INFORMATIVE,
        BIM_STATUS.ALL_OPEN_TICKET_ACCEPTED,
        BIM_STATUS.ALL_REFUND,
    ],
    BODY_WITH_MERCHANT_VARIATION: [
        BIM_STATUS.OPEN_TICKET_REJECTED,
        BIM_STATUS.REFUND,
    ],
};

export const OPEN_TICKET_PNR_STATUS = {
    ACCEPTED: 'ACCEPTED',
    PENDING: 'PENDING',
    REJECTED: 'REJECTED',
    REDEMPTION_PENDING: 'REDEMPTION_PENDING',
};

export const OPEN_TICKET_API_STATUS = {
    PROCESSING_REDEMPTION: 'PROCESSING_REDEMPTION',
};

export const REFUND_STEPS = [
    'REFUND_REQUESTED',
    'REFUND_PRIORITISING',
    'REFUND_PROCESSING',
    'REFUND_AIRLINE_REQUESTED',
    'REFUND_AIRLINE_PENDING',
    'REFUND_AIRLINE_APPROVED',
    'REFUND_FINALIZING',
];

export const CARRIER_CODES = {
    RYANAIR: 'FR',
    LAUDAMOTION: 'OE',
    VUELING: 'VY',
};

export const SURVEY_BRAND_PARAM_MAP = {
    ED: 'eDreams',
    OP: 'Opodo',
    GV: 'GoVoyages',
    TL: 'TravelLink',
};

export const SURVEY_LANG_EXCEPTIONS = {
    es_ES: 'es_ES',
    es_AR: 'es_419',
    es_CL: 'es_419',
    es_CO: 'es_419',
    es_MX: 'es_419',
    es_PE: 'es_419',
    es_US: 'es_419',
    zh_TW: 'zh_Hant_TW',
    zh_CN: 'zh_Hans',
};

export const TRACKING = {
    INCIDENTS_MANAGER_ACTION: 'incidents_manager',
    INTERMEDIATE_LAYER_ACTION: 'intermediate-layer',
    ONLOAD_LABEL_PREFIX: 'onload',
    LEGACY_ONLOAD_PARAMS: ['booking', 'PNR', 'id', 'pag'],
    ONLOAD_PARAMS: ['booking', 'type', 'semantic', 'status', 'includes', 'id', 'pag'],
    INVALID_CANCELLATION_PREFIX: 'invalid_cancellation',
    INVALID_CANCELLATION_PARAMS: ['booking', 'incident', 'id', 'pag'],
    CLICK_CTA_PREFIX: 'click-cta',
    CLICK_CTA_PARAMS: ['booking', 'type', 'semantic', 'status', 'includes', 'PNR', 'id', 'pag'],
    STATUS: {
        MANAGED_BY_TOUCHLESS: 'touchless',
        CONTACT_AIRLINE: 'contact',
        REFUND_WAITING_CONSENT: 'refund-waiting-consent',
        CUSTOMER_ALTERNATIVE_REQUESTED: 'customer-alternative-requested',
        CUSTOMER_ALTERNATIVE_ISSUED: 'customer-alternative-issued',
        OPEN_TICKET_ACCEPTED: 'flexYES',
        OPEN_TICKET_PENDING: 'flex',
        OPEN_TICKET_REJECTED: 'flexNO',
        REDEMPTION_PENDING: 'flexREDEEMED', // TBC
        BANKRUPTCY: 'bank',
        REFUND: 'refund',
        RESOLVED: 'resolved',
        RESOLVED_BY_CUSTOMER: 'resolved-by-customer',
        PENDING_CLASSIFICATION: 'pending',
        MMB: 'mgmt',
    },
};

export const BIM_UPDATE_CONSENT = {
    OPEN_TICKET_ACCEPTED: {
        flexibleTicketAccepted: true,
        cashRefundAccepted: false,
        flexibleTicketStatus: OPEN_TICKET_PNR_STATUS.ACCEPTED,
    },
    OPEN_TICKET_REJECTED: {
        flexibleTicketAccepted: false,
        cashRefundAccepted: true,
        flexibleTicketStatus: OPEN_TICKET_PNR_STATUS.REJECTED,
    },
    AIRLINE_ALTERNATIVE_ACCEPTED: {
        airlineAlternativeAccepted: true,
        cashRefundAccepted: false,
    },
    CASH_REFUND_REQUESTED: {
        airlineAlternativeAccepted: false,
        cashRefundAccepted: true,
    },
};

export const OPEN_TICKET_LIST_CONFIG = {
    [OPEN_TICKET_PNR_STATUS.ACCEPTED]: 'acceptedPNRs',
    [OPEN_TICKET_PNR_STATUS.PENDING]: 'pendingPNRs',
    [OPEN_TICKET_PNR_STATUS.REJECTED]: 'rejectedPNRs',
    [OPEN_TICKET_PNR_STATUS.REDEMPTION_PENDING]: 'redemptionPendingPNRs',
};
